@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treedetail.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.treedetail.resources/"

@delegate:ResourceContentHash(-662_203_971)
internal val Res.string.treedetail_photo_delete_dialog_title: StringResource by lazy {
      StringResource("string:treedetail_photo_delete_dialog_title", "treedetail_photo_delete_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15628, 76),
      ))
    }

@delegate:ResourceContentHash(-1_410_457_849)
internal val Res.string.treedetail_photo_deleted: StringResource by lazy {
      StringResource("string:treedetail_photo_deleted", "treedetail_photo_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15705, 56),
      ))
    }

@delegate:ResourceContentHash(-22_677_826)
internal val Res.string.treedetail_photo_empty: StringResource by lazy {
      StringResource("string:treedetail_photo_empty", "treedetail_photo_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15762, 58),
      ))
    }

@delegate:ResourceContentHash(1_724_373_786)
internal val Res.string.treedetail_photo_failed_description: StringResource by lazy {
      StringResource("string:treedetail_photo_failed_description", "treedetail_photo_failed_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15821, 67),
      ))
    }

@delegate:ResourceContentHash(1_070_257_778)
internal val Res.string.treedetail_photo_failed_tile_many: StringResource by lazy {
      StringResource("string:treedetail_photo_failed_tile_many", "treedetail_photo_failed_tile_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15889, 65),
      ))
    }

@delegate:ResourceContentHash(231_383_239)
internal val Res.string.treedetail_photo_failed_tile_one: StringResource by lazy {
      StringResource("string:treedetail_photo_failed_tile_one", "treedetail_photo_failed_tile_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15955, 56),
      ))
    }

@delegate:ResourceContentHash(1_286_393_384)
internal val Res.string.treedetail_photo_index: StringResource by lazy {
      StringResource("string:treedetail_photo_index", "treedetail_photo_index", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16012, 58),
      ))
    }

@delegate:ResourceContentHash(127_127_642)
internal val Res.string.treedetail_photo_more_count: StringResource by lazy {
      StringResource("string:treedetail_photo_more_count", "treedetail_photo_more_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16071, 43),
      ))
    }

@delegate:ResourceContentHash(1_354_725_093)
internal val Res.string.treedetail_photo_open_description: StringResource by lazy {
      StringResource("string:treedetail_photo_open_description", "treedetail_photo_open_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16115, 65),
      ))
    }

@delegate:ResourceContentHash(310_987_093)
internal val Res.string.treedetail_photo_report_description: StringResource by lazy {
      StringResource("string:treedetail_photo_report_description", "treedetail_photo_report_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16181, 71),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_photo_report_dialog_cancel: StringResource by lazy {
      StringResource("string:treedetail_photo_report_dialog_cancel", "treedetail_photo_report_dialog_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16253, 57),
      ))
    }

@delegate:ResourceContentHash(792_112_393)
internal val Res.string.treedetail_photo_report_dialog_confirm: StringResource by lazy {
      StringResource("string:treedetail_photo_report_dialog_confirm", "treedetail_photo_report_dialog_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16311, 58),
      ))
    }

@delegate:ResourceContentHash(13_490_540)
internal val Res.string.treedetail_photo_report_dialog_text: StringResource by lazy {
      StringResource("string:treedetail_photo_report_dialog_text", "treedetail_photo_report_dialog_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16370, 139),
      ))
    }

@delegate:ResourceContentHash(-1_310_681_594)
internal val Res.string.treedetail_photo_report_dialog_title: StringResource by lazy {
      StringResource("string:treedetail_photo_report_dialog_title", "treedetail_photo_report_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16510, 76),
      ))
    }

@delegate:ResourceContentHash(-6_765_894)
internal val Res.string.treedetail_photo_reported: StringResource by lazy {
      StringResource("string:treedetail_photo_reported", "treedetail_photo_reported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16587, 53),
      ))
    }

@delegate:ResourceContentHash(-1_495_112_346)
internal val Res.string.treedetail_photo_single_description: StringResource by lazy {
      StringResource("string:treedetail_photo_single_description", "treedetail_photo_single_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16641, 67),
      ))
    }

@delegate:ResourceContentHash(1_385_148_355)
internal val Res.string.treedetail_photo_view_all_description: StringResource by lazy {
      StringResource("string:treedetail_photo_view_all_description", "treedetail_photo_view_all_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16709, 77),
      ))
    }

@delegate:ResourceContentHash(-677_680_558)
internal val Res.string.treedetail_photo_view_page_description: StringResource by lazy {
      StringResource("string:treedetail_photo_view_page_description", "treedetail_photo_view_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16787, 70),
      ))
    }

@delegate:ResourceContentHash(1_825_425_977)
internal val Res.string.treedetail_planned_harvests_count_plural: StringResource by lazy {
      StringResource("string:treedetail_planned_harvests_count_plural", "treedetail_planned_harvests_count_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16858, 68),
      ))
    }

@delegate:ResourceContentHash(1_931_108_966)
internal val Res.string.treedetail_planned_harvests_count_singular: StringResource by lazy {
      StringResource("string:treedetail_planned_harvests_count_singular", "treedetail_planned_harvests_count_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16927, 66),
      ))
    }

@delegate:ResourceContentHash(-1_663_951_381)
internal val Res.string.treedetail_planned_harvests_title: StringResource by lazy {
      StringResource("string:treedetail_planned_harvests_title", "treedetail_planned_harvests_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16994, 65),
      ))
    }

@delegate:ResourceContentHash(-1_005_327_677)
internal val Res.string.treedetail_refresh_failed: StringResource by lazy {
      StringResource("string:treedetail_refresh_failed", "treedetail_refresh_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17060, 145),
      ))
    }

@delegate:ResourceContentHash(1_124_951_277)
internal val Res.string.treedetail_report_gone: StringResource by lazy {
      StringResource("string:treedetail_report_gone", "treedetail_report_gone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17206, 62),
      ))
    }

@delegate:ResourceContentHash(-1_339_818_987)
internal val Res.string.treedetail_report_maintain_identification: StringResource by lazy {
      StringResource("string:treedetail_report_maintain_identification", "treedetail_report_maintain_identification", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17269, 89),
      ))
    }

@delegate:ResourceContentHash(-309_369_055)
internal val Res.string.treedetail_report_withdraw_gone: StringResource by lazy {
      StringResource("string:treedetail_report_withdraw_gone", "treedetail_report_withdraw_gone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17359, 91),
      ))
    }

@delegate:ResourceContentHash(-1_795_508_464)
internal val Res.string.treedetail_roadside_warning_body: StringResource by lazy {
      StringResource("string:treedetail_roadside_warning_body", "treedetail_roadside_warning_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17451, 164),
      ))
    }

@delegate:ResourceContentHash(1_924_560_285)
internal val Res.string.treedetail_roadside_warning_title: StringResource by lazy {
      StringResource("string:treedetail_roadside_warning_title", "treedetail_roadside_warning_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17616, 81),
      ))
    }

@delegate:ResourceContentHash(904_474_558)
internal val Res.string.treedetail_season_legend_current: StringResource by lazy {
      StringResource("string:treedetail_season_legend_current", "treedetail_season_legend_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17698, 56),
      ))
    }

@delegate:ResourceContentHash(-1_725_957_657)
internal val Res.string.treedetail_season_legend_in_season: StringResource by lazy {
      StringResource("string:treedetail_season_legend_in_season", "treedetail_season_legend_in_season", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17755, 58),
      ))
    }

@delegate:ResourceContentHash(1_367_288_911)
internal val Res.string.treedetail_season_legend_soon: StringResource by lazy {
      StringResource("string:treedetail_season_legend_soon", "treedetail_season_legend_soon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17814, 57),
      ))
    }

@delegate:ResourceContentHash(2_001_889_762)
internal val Res.string.treedetail_share_description: StringResource by lazy {
      StringResource("string:treedetail_share_description", "treedetail_share_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17872, 48),
      ))
    }

@delegate:ResourceContentHash(434_570_611)
internal val Res.string.treedetail_share_failed: StringResource by lazy {
      StringResource("string:treedetail_share_failed", "treedetail_share_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17921, 75),
      ))
    }

@delegate:ResourceContentHash(11_853_682)
internal val Res.string.treedetail_share_link_copied: StringResource by lazy {
      StringResource("string:treedetail_share_link_copied", "treedetail_share_link_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17997, 52),
      ))
    }

@delegate:ResourceContentHash(1_233_903_058)
internal val Res.string.treedetail_site_attach: StringResource by lazy {
      StringResource("string:treedetail_site_attach", "treedetail_site_attach", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18050, 42),
      ))
    }

@delegate:ResourceContentHash(1_032_933_356)
internal val Res.string.treedetail_site_detach: StringResource by lazy {
      StringResource("string:treedetail_site_detach", "treedetail_site_detach", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18093, 42),
      ))
    }

@delegate:ResourceContentHash(-341_550_961)
internal val Res.string.treedetail_site_invite_only: StringResource by lazy {
      StringResource("string:treedetail_site_invite_only", "treedetail_site_invite_only", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18136, 91),
      ))
    }

@delegate:ResourceContentHash(-2_144_787_840)
internal val Res.string.treedetail_site_label: StringResource by lazy {
      StringResource("string:treedetail_site_label", "treedetail_site_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18228, 37),
      ))
    }

@delegate:ResourceContentHash(-280_299_525)
internal val Res.string.treedetail_site_none: StringResource by lazy {
      StringResource("string:treedetail_site_none", "treedetail_site_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18266, 56),
      ))
    }

@delegate:ResourceContentHash(1_187_514_836)
internal val Res.string.treedetail_site_not_now: StringResource by lazy {
      StringResource("string:treedetail_site_not_now", "treedetail_site_not_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18323, 51),
      ))
    }

@delegate:ResourceContentHash(-359_129_715)
internal val Res.string.treedetail_site_proposal_body: StringResource by lazy {
      StringResource("string:treedetail_site_proposal_body", "treedetail_site_proposal_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18375, 181),
      ))
    }

@delegate:ResourceContentHash(361_222_805)
internal val Res.string.treedetail_site_proposal_title: StringResource by lazy {
      StringResource("string:treedetail_site_proposal_title", "treedetail_site_proposal_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18557, 78),
      ))
    }

@delegate:ResourceContentHash(1_015_065_681)
internal val Res.string.treedetail_site_snackbar_attached: StringResource by lazy {
      StringResource("string:treedetail_site_snackbar_attached", "treedetail_site_snackbar_attached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18636, 73),
      ))
    }

@delegate:ResourceContentHash(589_985_923)
internal val Res.string.treedetail_site_snackbar_detached: StringResource by lazy {
      StringResource("string:treedetail_site_snackbar_detached", "treedetail_site_snackbar_detached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18710, 73),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_site_snackbar_undo: StringResource by lazy {
      StringResource("string:treedetail_site_snackbar_undo", "treedetail_site_snackbar_undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18852, 49),
      ))
    }

@delegate:ResourceContentHash(-2_022_964_308)
internal val Res.string.treedetail_site_snackbar_undone: StringResource by lazy {
      StringResource("string:treedetail_site_snackbar_undone", "treedetail_site_snackbar_undone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18784, 67),
      ))
    }

@delegate:ResourceContentHash(-2_048_701_646)
internal val Res.string.treedetail_species_photo_a11y: StringResource by lazy {
      StringResource("string:treedetail_species_photo_a11y", "treedetail_species_photo_a11y", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19054, 113),
      ))
    }

@delegate:ResourceContentHash(1_887_554_975)
internal val Res.string.treedetail_species_photo_a11y_credit_author: StringResource by lazy {
      StringResource("string:treedetail_species_photo_a11y_credit_author", "treedetail_species_photo_a11y_credit_author", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18902, 79),
      ))
    }

@delegate:ResourceContentHash(779_837_117)
internal val Res.string.treedetail_species_photo_a11y_credit_source: StringResource by lazy {
      StringResource("string:treedetail_species_photo_a11y_credit_source", "treedetail_species_photo_a11y_credit_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18982, 71),
      ))
    }

@delegate:ResourceContentHash(-145_874_531)
internal val Res.string.treedetail_species_photo_caption: StringResource by lazy {
      StringResource("string:treedetail_species_photo_caption", "treedetail_species_photo_caption", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19168, 88),
      ))
    }

@delegate:ResourceContentHash(-1_052_593_429)
internal val Res.string.treedetail_species_photo_credit_author: StringResource by lazy {
      StringResource("string:treedetail_species_photo_credit_author", "treedetail_species_photo_credit_author", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19257, 70),
      ))
    }

@delegate:ResourceContentHash(505_410_501)
internal val Res.string.treedetail_species_photo_credit_source: StringResource by lazy {
      StringResource("string:treedetail_species_photo_credit_source", "treedetail_species_photo_credit_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19328, 62),
      ))
    }

@delegate:ResourceContentHash(-1_624_967_384)
internal val Res.string.treedetail_start_harvest: StringResource by lazy {
      StringResource("string:treedetail_start_harvest", "treedetail_start_harvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19391, 60),
      ))
    }

@delegate:ResourceContentHash(1_603_921_239)
internal val Res.string.treedetail_trait_access_difficult: StringResource by lazy {
      StringResource("string:treedetail_trait_access_difficult", "treedetail_trait_access_difficult", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19452, 65),
      ))
    }

@delegate:ResourceContentHash(-244_386_132)
internal val Res.string.treedetail_trait_delicious: StringResource by lazy {
      StringResource("string:treedetail_trait_delicious", "treedetail_trait_delicious", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19518, 50),
      ))
    }

@delegate:ResourceContentHash(1_645_407_850)
internal val Res.string.treedetail_trait_description_mine_suffix: StringResource by lazy {
      StringResource("string:treedetail_trait_description_mine_suffix", "treedetail_trait_description_mine_suffix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19569, 72),
      ))
    }

@delegate:ResourceContentHash(-2_135_018_342)
internal val Res.string.treedetail_trait_description_plural: StringResource by lazy {
      StringResource("string:treedetail_trait_description_plural", "treedetail_trait_description_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19642, 79),
      ))
    }

@delegate:ResourceContentHash(-2_135_018_434)
internal val Res.string.treedetail_trait_description_singular: StringResource by lazy {
      StringResource("string:treedetail_trait_description_singular", "treedetail_trait_description_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19722, 81),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("treedetail_photo_delete_dialog_title", Res.string.treedetail_photo_delete_dialog_title)
  map.put("treedetail_photo_deleted", Res.string.treedetail_photo_deleted)
  map.put("treedetail_photo_empty", Res.string.treedetail_photo_empty)
  map.put("treedetail_photo_failed_description", Res.string.treedetail_photo_failed_description)
  map.put("treedetail_photo_failed_tile_many", Res.string.treedetail_photo_failed_tile_many)
  map.put("treedetail_photo_failed_tile_one", Res.string.treedetail_photo_failed_tile_one)
  map.put("treedetail_photo_index", Res.string.treedetail_photo_index)
  map.put("treedetail_photo_more_count", Res.string.treedetail_photo_more_count)
  map.put("treedetail_photo_open_description", Res.string.treedetail_photo_open_description)
  map.put("treedetail_photo_report_description", Res.string.treedetail_photo_report_description)
  map.put("treedetail_photo_report_dialog_cancel", Res.string.treedetail_photo_report_dialog_cancel)
  map.put("treedetail_photo_report_dialog_confirm", Res.string.treedetail_photo_report_dialog_confirm)
  map.put("treedetail_photo_report_dialog_text", Res.string.treedetail_photo_report_dialog_text)
  map.put("treedetail_photo_report_dialog_title", Res.string.treedetail_photo_report_dialog_title)
  map.put("treedetail_photo_reported", Res.string.treedetail_photo_reported)
  map.put("treedetail_photo_single_description", Res.string.treedetail_photo_single_description)
  map.put("treedetail_photo_view_all_description", Res.string.treedetail_photo_view_all_description)
  map.put("treedetail_photo_view_page_description", Res.string.treedetail_photo_view_page_description)
  map.put("treedetail_planned_harvests_count_plural", Res.string.treedetail_planned_harvests_count_plural)
  map.put("treedetail_planned_harvests_count_singular", Res.string.treedetail_planned_harvests_count_singular)
  map.put("treedetail_planned_harvests_title", Res.string.treedetail_planned_harvests_title)
  map.put("treedetail_refresh_failed", Res.string.treedetail_refresh_failed)
  map.put("treedetail_report_gone", Res.string.treedetail_report_gone)
  map.put("treedetail_report_maintain_identification", Res.string.treedetail_report_maintain_identification)
  map.put("treedetail_report_withdraw_gone", Res.string.treedetail_report_withdraw_gone)
  map.put("treedetail_roadside_warning_body", Res.string.treedetail_roadside_warning_body)
  map.put("treedetail_roadside_warning_title", Res.string.treedetail_roadside_warning_title)
  map.put("treedetail_season_legend_current", Res.string.treedetail_season_legend_current)
  map.put("treedetail_season_legend_in_season", Res.string.treedetail_season_legend_in_season)
  map.put("treedetail_season_legend_soon", Res.string.treedetail_season_legend_soon)
  map.put("treedetail_share_description", Res.string.treedetail_share_description)
  map.put("treedetail_share_failed", Res.string.treedetail_share_failed)
  map.put("treedetail_share_link_copied", Res.string.treedetail_share_link_copied)
  map.put("treedetail_site_attach", Res.string.treedetail_site_attach)
  map.put("treedetail_site_detach", Res.string.treedetail_site_detach)
  map.put("treedetail_site_invite_only", Res.string.treedetail_site_invite_only)
  map.put("treedetail_site_label", Res.string.treedetail_site_label)
  map.put("treedetail_site_none", Res.string.treedetail_site_none)
  map.put("treedetail_site_not_now", Res.string.treedetail_site_not_now)
  map.put("treedetail_site_proposal_body", Res.string.treedetail_site_proposal_body)
  map.put("treedetail_site_proposal_title", Res.string.treedetail_site_proposal_title)
  map.put("treedetail_site_snackbar_attached", Res.string.treedetail_site_snackbar_attached)
  map.put("treedetail_site_snackbar_detached", Res.string.treedetail_site_snackbar_detached)
  map.put("treedetail_site_snackbar_undo", Res.string.treedetail_site_snackbar_undo)
  map.put("treedetail_site_snackbar_undone", Res.string.treedetail_site_snackbar_undone)
  map.put("treedetail_species_photo_a11y", Res.string.treedetail_species_photo_a11y)
  map.put("treedetail_species_photo_a11y_credit_author", Res.string.treedetail_species_photo_a11y_credit_author)
  map.put("treedetail_species_photo_a11y_credit_source", Res.string.treedetail_species_photo_a11y_credit_source)
  map.put("treedetail_species_photo_caption", Res.string.treedetail_species_photo_caption)
  map.put("treedetail_species_photo_credit_author", Res.string.treedetail_species_photo_credit_author)
  map.put("treedetail_species_photo_credit_source", Res.string.treedetail_species_photo_credit_source)
  map.put("treedetail_start_harvest", Res.string.treedetail_start_harvest)
  map.put("treedetail_trait_access_difficult", Res.string.treedetail_trait_access_difficult)
  map.put("treedetail_trait_delicious", Res.string.treedetail_trait_delicious)
  map.put("treedetail_trait_description_mine_suffix", Res.string.treedetail_trait_description_mine_suffix)
  map.put("treedetail_trait_description_plural", Res.string.treedetail_trait_description_plural)
  map.put("treedetail_trait_description_singular", Res.string.treedetail_trait_description_singular)
}
